import type { AgentFailure } from "@magnis/client-core";

export function agentFailureCopy(error: AgentFailure): string {
  switch (error.kind) {
    case "credit_exhausted":
      return "Your $1 demo agent credit has been used. You can still explore all demo data.";
    case "provider":
      return error.retryable
        ? "The demo agent is temporarily unavailable. Please try again."
        : "The demo agent is unavailable right now.";
    case "unexpected":
      return "The demo agent could not complete this request. Please try again.";
  }
}
